module.exports = __webpack_public_path__ + "img/13.4b16a954.png";